





















import { Vue, Component, Prop } from 'vue-property-decorator';

import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';

import { fetchMS } from './fetchMS';

import PopUpGenerateReports from './PopUpGenerateReports.vue';

import { ParamApi } from '@/pantallas/Conecta/Equipos/models/Equipos.model';

@Component({ components: { PopUpGenerateReports } })
export default class EquiposActions extends Vue {
  @Prop({ required: true, default: {} }) paramApi!: ParamApi;
  @Prop({ required: true, default: [] }) dataList!: any[];

  showInfo: boolean = true;
  readonly loadingService: LoadingService = new LoadingService();
  readonly $snotify: Snotify = null;

  msgReport: string = '';
  dialogPopUp: boolean = false;

  handleCloseReport() {
    this.dialogPopUp = false;
    this.msgReport = '';
  }

  handleCreate() {
    this.$emit('openModal', true);
  }
  async getCSV() {
    const { length: count } = this.dataList;
    if (!count) {
      this.$snotify.error('No hay datos disponibles para generar el reporte', {
        timeout: 3000,
      });
      return;
    }
    try {
      console.log(this.paramApi);
      const userId = JSON.parse(localStorage.getItem('user')).id;
      const user = localStorage.getItem('clienteDefecto');
      this.loadingService.showLoading(null, 'getCSV');
      const serienumero = (this.paramApi.serienumero || '').trim();
      const body = {
        userId: JSON.parse(localStorage.getItem('user')).id || '',
        user: localStorage.getItem('clienteDefecto') || '',
        serienumero,
        tipoeqid: this.paramApi.equipo ? this.paramApi.equipo.tipoeqid : '',
        fechacarga: this.paramApi.fechacarga ? this.paramApi.fechacarga : '',
        dict_params: { ...this.paramApi },
      };
      const result = await fetchMS({
        endpoint: 'export_excel',
        body,
      });
      const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);

      if (cod !== 1) {
        throw new Error(MENSAJE_RESPUESTA);
      }
      this.msgReport = MENSAJE_RESPUESTA;
      this.dialogPopUp = true;
    } catch (error) {
      if (error instanceof Error && error.message !== 'Network Error') {
        this.$snotify.error(error.message, { timeout: 3000 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading('getCSV');
    }
  }
}
